<mat-tab-group animationDuration="0ms" color="transparent" disablePagination>
  <mat-tab label="{{ 'Details' | transloco }}">
    <div class="sidebar-content--detail-tab">
      <sidebar-title-description
        [description]="widget().component.description"
        [disableDescription]="true"
        [title]="widget().component.title"
        (titleChange)="handleTitleChanged($event)" />

      <tt-divider class="tt-guideline-sidebar_divider" />

      <tt-guideline-component-sidebar-basics
        [attachments]="widget().attachments"
        [links]="widget().links"
        [references]="widget().references"
        [resourceTags]="widget().resourceTags"
        (basicsChanged)="handleBasicsChanged($event)" />
    </div>
  </mat-tab>
  @if (!showAllMedications() && !widget().component.proposedComponent) {
    <mat-tab label="{{ 'TechnicalInfo' | transloco }}">
      <sidebar-technical-info [guidelineComponent]="widget().component.conditionDefinition" [label]="'ConditionDefinition' | transloco" />
    </mat-tab>
  }
</mat-tab-group>
